import React from 'react';
import { LibBigCalendar } from './BigCalendar.style';

const BigCalendar = ({ ...restProps }) => {
  return <LibBigCalendar {...restProps} />;
};

export default BigCalendar;
export { BigCalendar };
